// extracted by mini-css-extract-plugin
module.exports = {"icon":"Tooltip_icon__253bd"};